var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          ref: "drawer",
          attrs: {
            "append-to-body": true,
            title: _vm.titleName,
            visible: _vm.newSiteDrawer,
            direction: "ltr",
            size: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.newSiteDrawer = $event
            },
            close: _vm.cancelForm,
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                padding: "0 20px",
                height: "calc(100vh - 67px)",
                overflow: "auto",
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "addForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    "label-position":
                      _vm.$i18n.locale != "zh" ? "top" : "right",
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "cardClass",
                          attrs: { shadow: "never" },
                        },
                        [
                          _c("div", { staticClass: "title_top_class" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("collectionCenter.branchBasicInfo")
                                ) +
                                " "
                            ),
                          ]),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.siteNum"),
                                    prop: "code",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseInput"
                                          ),
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.ruleForm.code,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "code",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.code",
                                        },
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.ruleForm.code || "--")
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.siteName"),
                                    prop: "name",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c("el-input", {
                                        attrs: {
                                          maxlength: 100,
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseInput"
                                          ),
                                          clearable: "",
                                          "show-word-limit": "",
                                          rows: 1,
                                        },
                                        model: {
                                          value: _vm.ruleForm.name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "name",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.name",
                                        },
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.ruleForm.name || "--")
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.businessModel"
                                    ),
                                    prop: "businessModel",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "placeOrder.pleaseChoose"
                                            ),
                                            clearable: "",
                                            filterable: "",
                                          },
                                          on: {
                                            change: _vm.changeBusinessModel,
                                          },
                                          model: {
                                            value: _vm.ruleForm.businessModel,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "businessModel",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "ruleForm.businessModel",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.isAll === 1 ||
                                                  _vm.isAll === 0,
                                                expression:
                                                  "isAll === 1 || isAll === 0",
                                              },
                                            ],
                                            attrs: {
                                              value: 1,
                                              label: _vm.$t(
                                                "collectionCenter.directSales"
                                              ),
                                            },
                                          }),
                                          _c("el-option", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.isAll === 2 ||
                                                  _vm.isAll === 0,
                                                expression:
                                                  "isAll === 2 || isAll === 0",
                                              },
                                            ],
                                            attrs: {
                                              value: 2,
                                              label: _vm.$t(
                                                "collectionCenter.joinSales"
                                              ),
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              value: 3,
                                              label: _vm.$t(
                                                "collectionCenter.exclusive"
                                              ),
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [_vm._v(_vm._s(_vm.businessModelLabel))]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.dotTypeCode"
                                    ),
                                    prop: "siteType",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "placeOrder.pleaseChoose"
                                            ),
                                            clearable: "",
                                            filterable: "",
                                          },
                                          on: { change: _vm.changeSiteType },
                                          model: {
                                            value: _vm.ruleForm.siteType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "siteType",
                                                $$v
                                              )
                                            },
                                            expression: "ruleForm.siteType",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "collectionCenter.hut"
                                              ),
                                              value: 1,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "collectionCenter.dot"
                                              ),
                                              value: 2,
                                            },
                                          }),
                                          _c("el-option", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.ruleForm.businessModel !=
                                                  2,
                                                expression:
                                                  "ruleForm.businessModel != 2",
                                              },
                                            ],
                                            attrs: {
                                              label: _vm.$t(
                                                "collectionCenter.transferCenter"
                                              ),
                                              value: 3,
                                            },
                                          }),
                                          _c("el-option", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.ruleForm.businessModel !=
                                                  2,
                                                expression:
                                                  "ruleForm.businessModel != 2",
                                              },
                                            ],
                                            attrs: {
                                              label: _vm.$t(
                                                "collectionCenter.headOffice"
                                              ),
                                              value: 4,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "inline-block",
                                            width: "100%",
                                            "pointer-events": "none",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticStyle: { color: "#424242" },
                                              attrs: {
                                                type: "primary",
                                                size: "small",
                                                plain: "",
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.siteTypeLabel))]
                                          ),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.businessT"),
                                    prop: "businessType",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "placeOrder.pleaseChoose"
                                            ),
                                            clearable: "",
                                            "collapse-tags": "",
                                            filterable: "",
                                            multiple: "",
                                          },
                                          on: {
                                            change: _vm.changeBusinessType,
                                          },
                                          model: {
                                            value: _vm.ruleForm.businessType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "businessType",
                                                $$v
                                              )
                                            },
                                            expression: "ruleForm.businessType",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: ![1, 2, 5].includes(
                                                  _vm.ruleForm.siteType
                                                ),
                                                expression:
                                                  "![1, 2, 5].includes(ruleForm.siteType)",
                                              },
                                            ],
                                            attrs: {
                                              label: _vm.$t(
                                                "collectionCenter.turnTransport"
                                              ),
                                              value: 1,
                                            },
                                          }),
                                          _c("el-option", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.ruleForm.siteType != 3,
                                                expression:
                                                  "ruleForm.siteType != 3",
                                              },
                                            ],
                                            attrs: {
                                              label: _vm.$t(
                                                "collectionCenter.smallCollect"
                                              ),
                                              value: 2,
                                            },
                                          }),
                                          _c("el-option", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.ruleForm.siteType != 3,
                                                expression:
                                                  "ruleForm.siteType != 3",
                                              },
                                            ],
                                            attrs: {
                                              label: _vm.$t(
                                                "collectionCenter.smallDelivery"
                                              ),
                                              value: 3,
                                            },
                                          }),
                                          _c("el-option", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.ruleForm.siteType != 3,
                                                expression:
                                                  "ruleForm.siteType != 3",
                                              },
                                            ],
                                            attrs: {
                                              label: _vm.$t(
                                                "collectionCenter.largeDelivery"
                                              ),
                                              value: 4,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm.businessTypeLabel
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "inline-block",
                                              width: "100%",
                                            },
                                          },
                                          _vm._l(
                                            _vm.businessTypeLabel.split("、"),
                                            function (label, index) {
                                              return _c(
                                                "el-button",
                                                {
                                                  key: index,
                                                  staticStyle: {
                                                    "pointer-events": "none",
                                                    "margin-bottom": "2px",
                                                    color: "#424242",
                                                  },
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small",
                                                    plain: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(label) + " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ]
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [_vm._v("--")]
                                      ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "basicData.BusinessPrincipal"
                                    ),
                                    prop: "businessPrincipal",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "orderDetails.pleaseChoose"
                                            ),
                                            clearable: "",
                                            filterable: "",
                                          },
                                          on: {
                                            change: _vm.changeBusinessPrincipal,
                                          },
                                          model: {
                                            value:
                                              _vm.ruleForm.businessPrincipal,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "businessPrincipal",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "ruleForm.businessPrincipal",
                                          },
                                        },
                                        _vm._l(
                                          _vm.businessPrincipalList,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.providerCode,
                                                value: item.providerId,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.businessPrincipalLabel)
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "GlobalSetObj.ServiceProviderChannels"
                                    ),
                                    prop: "providerChannelCode",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "GlobalSetObj.pleaseChoose"
                                            ),
                                            clearable: "",
                                            filterable: "",
                                          },
                                          model: {
                                            value:
                                              _vm.ruleForm.providerChannelCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "providerChannelCode",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "ruleForm.providerChannelCode",
                                          },
                                        },
                                        _vm._l(
                                          _vm.providerChannelNameList,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.name,
                                                value: item.code,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.providerChannelLabel)
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.owningTransitCenter1"
                                    ),
                                    prop: "department",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "GlobalSetObj.pleaseChoose"
                                            ),
                                            clearable: "",
                                            filterable: "",
                                          },
                                          model: {
                                            value: _vm.ruleForm.department,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "department",
                                                $$v
                                              )
                                            },
                                            expression: "ruleForm.department",
                                          },
                                        },
                                        _vm._l(
                                          _vm.departmentList,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.name,
                                                value: item.name,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ruleForm.department || "--"
                                            )
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("bank.contact") } },
                                [
                                  _vm.isModify
                                    ? _c("el-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseInput"
                                          ),
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.ruleForm.contactsName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "contactsName",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.contactsName",
                                        },
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ruleForm.contactsName || "--"
                                            )
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.contactTel"
                                    ),
                                    prop: "contactsTel",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c("el-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseInput"
                                          ),
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.ruleForm.contactsTel,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "contactsTel",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.contactsTel",
                                        },
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ruleForm.contactsTel || "--"
                                            )
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("GlobalSetObj.contactEmail"),
                                    prop: "mailBox",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c("el-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseInput"
                                          ),
                                          clearable: "",
                                          maxlength: "64",
                                          "show-word-limit": "",
                                        },
                                        model: {
                                          value: _vm.ruleForm.mailBox,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "mailBox",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.mailBox",
                                        },
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.ruleForm.mailBox || "--")
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-card",
                        {
                          staticClass: "cardClass",
                          attrs: { shadow: "never" },
                        },
                        [
                          _c("div", { staticClass: "title_top_class" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("collectionCenter.branchOperationInfo")
                                ) +
                                " "
                            ),
                          ]),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.smallCollectRange"
                                    ),
                                    prop: "collectRange",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c(
                                        "div",
                                        [
                                          _c("el-input", {
                                            staticStyle: { display: "none" },
                                            model: {
                                              value: _vm.ruleForm.collectRange,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.ruleForm,
                                                  "collectRange",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "ruleForm.collectRange",
                                            },
                                          }),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "primary" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.rangeCodeInfoShow(
                                                    _vm.$t(
                                                      "collectionCenter.smallCollectRange"
                                                    ),
                                                    2,
                                                    _vm.ruleForm.collectRange
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(_vm.btnName) + " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            width: "60%",
                                          },
                                        },
                                        [
                                          _vm.ruleForm.collectRange
                                            ? _c(
                                                "span",
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "10px",
                                                        cursor: "pointer",
                                                        "flex-shrink": "0",
                                                      },
                                                      attrs: {
                                                        type: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.readCodeRange(
                                                            _vm.$t(
                                                              "collectionCenter.smallCollectRange"
                                                            ),
                                                            _vm.ruleForm
                                                              .collectRange
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(_vm.btnName) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "10px",
                                                  },
                                                },
                                                [_vm._v("--")]
                                              ),
                                        ]
                                      ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.smallDeliveryRange"
                                    ),
                                    prop: "deliveryRange",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c(
                                        "div",
                                        [
                                          _c("el-input", {
                                            staticStyle: { display: "none" },
                                            model: {
                                              value: _vm.ruleForm.deliveryRange,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.ruleForm,
                                                  "deliveryRange",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "ruleForm.deliveryRange",
                                            },
                                          }),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "primary" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.rangeCodeInfoShow(
                                                    _vm.$t(
                                                      "collectionCenter.smallDeliveryRange"
                                                    ),
                                                    3,
                                                    _vm.ruleForm.deliveryRange
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(_vm.btnName) + " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            width: "60%",
                                          },
                                        },
                                        [
                                          _vm.ruleForm.deliveryRange
                                            ? _c(
                                                "span",
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "10px",
                                                        cursor: "pointer",
                                                        "flex-shrink": "0",
                                                      },
                                                      attrs: {
                                                        type: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.readCodeRange(
                                                            _vm.$t(
                                                              "collectionCenter.smallDeliveryRange"
                                                            ),
                                                            _vm.ruleForm
                                                              .deliveryRange
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(_vm.btnName) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "10px",
                                                  },
                                                },
                                                [_vm._v("--")]
                                              ),
                                        ]
                                      ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.largeDeliveryRange"
                                    ),
                                    prop: "bulkyDeliverZipCode",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c(
                                        "div",
                                        [
                                          _c("el-input", {
                                            staticStyle: { display: "none" },
                                            model: {
                                              value:
                                                _vm.ruleForm
                                                  .bulkyDeliverZipCode,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.ruleForm,
                                                  "bulkyDeliverZipCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "ruleForm.bulkyDeliverZipCode",
                                            },
                                          }),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "primary" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.rangeCodeInfoShow(
                                                    _vm.$t(
                                                      "collectionCenter.largeDeliveryRange"
                                                    ),
                                                    4,
                                                    _vm.ruleForm
                                                      .bulkyDeliverZipCode
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(_vm.btnName) + " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            width: "60%",
                                          },
                                        },
                                        [
                                          _vm.ruleForm.bulkyDeliverZipCode
                                            ? _c(
                                                "span",
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "10px",
                                                        cursor: "pointer",
                                                        "flex-shrink": "0",
                                                      },
                                                      attrs: {
                                                        type: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.readCodeRange(
                                                            _vm.$t(
                                                              "collectionCenter.largeDeliveryRange"
                                                            ),
                                                            _vm.ruleForm
                                                              .bulkyDeliverZipCode
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(_vm.btnName) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "10px",
                                                  },
                                                },
                                                [_vm._v("--")]
                                              ),
                                        ]
                                      ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("base.openingHours") },
                                },
                                [
                                  _vm.isModify
                                    ? _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            cursor: "pointer",
                                            "flex-shrink": "0",
                                          },
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.rangeInfoShow(
                                                _vm.ruleForm
                                                  .siteBusinessTimeData
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(_vm.btnName) + " "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            width: "100%",
                                          },
                                        },
                                        [
                                          _vm.ruleForm.siteBusinessTimeData &&
                                          _vm.ruleForm.siteBusinessTimeData
                                            .length > 0
                                            ? _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    "flex-shrink": "0",
                                                  },
                                                  attrs: { type: "primary" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.checkTimeFn(
                                                        _vm.ruleForm
                                                          .siteBusinessTimeData
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.btnName) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "10px",
                                                  },
                                                },
                                                [_vm._v("--")]
                                              ),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.ifUse"),
                                    prop: "siteStatus",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "placeOrder.pleaseChoose"
                                            ),
                                            clearable: "",
                                            filterable: "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.siteStatusChange()
                                            },
                                          },
                                          model: {
                                            value: _vm.ruleForm.siteStatus,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "siteStatus",
                                                $$v
                                              )
                                            },
                                            expression: "ruleForm.siteStatus",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "collectionCenter.enable"
                                              ),
                                              value: 1,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "collectionCenter.Disable"
                                              ),
                                              value: 0,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [_vm._v(_vm._s(_vm.siteStatusLabel))]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.contractSigned"
                                    ),
                                    prop: "contractSigned",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "placeOrder.pleaseChoose"
                                            ),
                                            clearable: "",
                                            filterable: "",
                                          },
                                          model: {
                                            value: _vm.ruleForm.contractSigned,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "contractSigned",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "ruleForm.contractSigned",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t("GlobalSetObj.yes"),
                                              value: 1,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t("GlobalSetObj.No"),
                                              value: 0,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.contractSignedLabel)
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-card",
                        {
                          staticClass: "cardClass",
                          attrs: { shadow: "never" },
                        },
                        [
                          _c("div", { staticClass: "title_top_class" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("collectionCenter.branchAddressInfo")
                                ) +
                                " "
                            ),
                          ]),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.zipCodeTitle"
                                    ),
                                    prop: "zipCode",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "collectionCenter.input8ZipCode"
                                          ),
                                          clearable: "",
                                          maxlength: "8",
                                        },
                                        model: {
                                          value: _vm.ruleForm.zipCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "zipCode",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.zipCode",
                                        },
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.ruleForm.zipCode || "--")
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          [2, 3].includes(_vm.ruleForm.siteType)
                            ? _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "orderCenterCont.BelongsToTheRegion"
                                        ),
                                        prop: "regionId",
                                      },
                                    },
                                    [
                                      _vm.isModify
                                        ? _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                placeholder: _vm.$t(
                                                  "placeOrder.pleaseChoose"
                                                ),
                                                clearable: "",
                                                filterable: "",
                                              },
                                              on: {
                                                change: _vm.regionChangeOption,
                                              },
                                              model: {
                                                value: _vm.ruleForm.regionId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.ruleForm,
                                                    "regionId",
                                                    $$v
                                                  )
                                                },
                                                expression: "ruleForm.regionId",
                                              },
                                            },
                                            _vm._l(
                                              _vm.regionList,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.id,
                                                  attrs: {
                                                    label:
                                                      item.zhName +
                                                      "（" +
                                                      item.puName +
                                                      "）",
                                                    value: item.id,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        : _c(
                                            "span",
                                            { staticClass: "nameCode-class" },
                                            [_vm._v(_vm._s(_vm.regionLabel))]
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.stateSite"),
                                    prop: "state",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "GlobalSetObj.pleaseChoose"
                                            ),
                                            clearable: "",
                                            filterable: "",
                                            size: "small",
                                          },
                                          on: { change: _vm.stateChangeOption },
                                          model: {
                                            value: _vm.ruleForm.state,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "state",
                                                $$v
                                              )
                                            },
                                            expression: "ruleForm.state",
                                          },
                                        },
                                        _vm._l(_vm.StateList, function (item) {
                                          return _c("el-option", {
                                            key: item.id,
                                            attrs: {
                                              label: item.label,
                                              value: item.label,
                                            },
                                          })
                                        }),
                                        1
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.ruleForm.state || "--")
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.city"),
                                    prop: "city",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "GlobalSetObj.pleaseChoose"
                                            ),
                                            clearable: "",
                                            filterable: "",
                                            size: "small",
                                            remote: "",
                                            "reserve-keyword": "",
                                            "remote-method": _vm.getState,
                                          },
                                          on: { clear: _vm.stateChangeOption },
                                          model: {
                                            value: _vm.ruleForm.city,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "city",
                                                $$v
                                              )
                                            },
                                            expression: "ruleForm.city",
                                          },
                                        },
                                        _vm._l(_vm.cityList, function (item) {
                                          return _c("el-option", {
                                            key: item.id,
                                            attrs: {
                                              label: item.name,
                                              value: item.name,
                                            },
                                          })
                                        }),
                                        1
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.ruleForm.city || "--")
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.area"),
                                    prop: "area",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c("el-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseInput"
                                          ),
                                          clearable: "",
                                          maxlength: "50",
                                        },
                                        model: {
                                          value: _vm.ruleForm.area,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "area",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.area",
                                        },
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.ruleForm.area || "--")
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("newOrder.Street"),
                                    prop: "street",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c("el-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseInput"
                                          ),
                                          clearable: "",
                                          maxlength: "80",
                                        },
                                        model: {
                                          value: _vm.ruleForm.street,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "street",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.street",
                                        },
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.ruleForm.street || "--")
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "orderCenterCont.HouseNumber"
                                    ),
                                    prop: "houseNumber",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c("el-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseInput"
                                          ),
                                          clearable: "",
                                          maxlength: "14",
                                        },
                                        model: {
                                          value: _vm.ruleForm.houseNumber,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "houseNumber",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.houseNumber",
                                        },
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ruleForm.houseNumber || "--"
                                            )
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "placeOrder.addressComplement"
                                    ),
                                    prop: "address",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c("el-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseInput"
                                          ),
                                          clearable: "",
                                          maxlength: "500",
                                          "show-word-limit": "",
                                        },
                                        model: {
                                          value: _vm.ruleForm.address,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "address",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.address",
                                        },
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.ruleForm.address || "--")
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("orderCenterCont.longitude"),
                                    prop: "longitude",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c("el-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseInput"
                                          ),
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.ruleForm.longitude,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "longitude",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.longitude",
                                        },
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ruleForm.longitude || "--"
                                            )
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("orderCenterCont.latitude"),
                                    prop: "latitude",
                                  },
                                },
                                [
                                  _vm.isModify
                                    ? _c("el-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseInput"
                                          ),
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.ruleForm.latitude,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "latitude",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.latitude",
                                        },
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "nameCode-class" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ruleForm.latitude || "--"
                                            )
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.isModify
                        ? _c(
                            "el-col",
                            {
                              staticStyle: { float: "right" },
                              attrs: { span: 15 },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    float: "right",
                                    height: "60px",
                                    "margin-top": "20px",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.resetClick($event)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("collectionCenter.empty")
                                        ) + " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        "margin-left": "20px",
                                        "margin-right": "20px",
                                      },
                                      on: { click: _vm.cancelForm },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("GlobalSetObj.Cancelar")
                                        ) + " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.saveForm },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("GlobalSetObj.Salve")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("rangeInfo", {
        ref: "rangeInfoRef",
        attrs: { "rule-form": _vm.ruleForm },
        on: { childrenData: _vm.rangeInfoData },
      }),
      _c("siteBusinessTime", {
        ref: "siteBusinessTimeRef",
        on: { getDate: _vm.timeDate },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }